import {buildDescriptorControl} from "../descriptorcontrols/ControlResolver";

export default (props) => buildDescriptorControl("StringField", "dropdown", props);



// WEBPACK FOOTER //
// ./app/lib/common/controls/Select.js